import React, {useCallback, useState} from 'react';
import {Divider, Stack} from "@mui/material";
import ListOfFeeds from "./components/ListOfFeeds";
import FeedItems from "./components/FeedItems";
import FeedPreviewPanel from "./components/FeedPreviewPanel";

const FeedsPage = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const handleFeedUpdated = useCallback(() => setRefreshKey(k => k + 1), []);

    return (
        <Stack overflow={'hidden'} flex={1}>
            <Stack
                direction={'row'}
                overflow={'hidden'}
                flex={1}
            >

                <Stack
                    width={'20%'}
                    bgcolor={'white'}
                    overflow={'auto'}
                >
                    <ListOfFeeds refreshKey={refreshKey} onFeedCreated={handleFeedUpdated}/>
                </Stack>

                <Divider orientation={'vertical'}/>

                <Stack
                    width={'40%'}
                    bgcolor={'white'}
                    overflow={'auto'}
                >
                    <FeedItems onFeedUpdated={handleFeedUpdated} refreshKey={refreshKey}/>
                </Stack>

                <Divider orientation={'vertical'}/>

                <Stack
                    width={'40%'}
                    bgcolor={'white'}
                    overflow={'hidden'}
                >
                    <FeedPreviewPanel/>
                </Stack>

            </Stack>
        </Stack>
    );
};

export default FeedsPage;